// extracted by mini-css-extract-plugin
export default {"emptyContainer":"DocsList_emptyContainer__Koz3u","emptyIcon":"DocsList_emptyIcon__zN+H0"};